export default __webpack_public_path__ + "static/media/filter.069d192b.svg";